import { BlankState } from '@domain-group/suit-theme'

import BlankStateImageUrl from './assets/no-links.svg'

const TrackingLinksBlankState = () => (
  <BlankState style={{ alignItems: 'center', justifyContent: 'space-between' }} imageUrl={BlankStateImageUrl}>
    <BlankState.Title>
      No Tracking Links Available
    </BlankState.Title>

    <BlankState.Paragraph>
      You don&apos;t have any tracking links attached to this campaign.
      Tracking Links are enabled when artworks are created that have QR Codes.
    </BlankState.Paragraph>
  </BlankState>
)

export default TrackingLinksBlankState
